import React from 'react';
import { EuiIcon } from "@elastic/eui";

export default (props: any) => {
  const cellValue = props.value;

  const buttonClicked = () => {
    // alert(`${cellValue} `);
    console.log('buttonClicked', props);
    props.onClick(props.data.idCentro, props.data.idPais, !props.data.noMostrar);
  };

  return (
    <EuiIcon type={(cellValue ? "eyeClosed" : "eye")} color={(cellValue ? "red" : "green")} size="m" onClick={buttonClicked} />
  );
};